module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//blue_3.png?v=6e9e2125";